<template>
  <div id="app">
    <!-- Navbar fijo -->
    <nav class="navbar-fixed flex-column align-items-end">
      <h1 class="brand-title">Miss Coquette</h1>
      <small class="fecha-hora">{{ fechaHora }}</small>
    </nav>

    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      fechaHora: ''
    };
  },
  methods: {
    actualizarFechaHora() {
      const ahora = new Date();
      const opciones = {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      };
      this.fechaHora = ahora.toLocaleDateString('es-MX', opciones);
    }
  },
  mounted() {
    this.actualizarFechaHora();
    setInterval(this.actualizarFechaHora, 60000); // actualiza cada minuto
  }
};
</script>

<style>
/* Estilo del navbar */
.navbar-fixed {
  position: fixed;
  top: 10px;
  right: 0;
  left: 10px;
  height: auto; /* ajustamos para que permita ver dos líneas */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding-right: 40px;
  z-index: 1000;
}

/* Título de la marca */
.brand-title {
  font-size: 1rem;
  color: #c36aa0;
  font-family: 'jour';
  margin-bottom: 2px;
}

/* Fecha y hora debajo del título */
.fecha-hora {
  font-size: 0.75rem;
  color: #888;
  margin-right: 2px;
  font-family: 'sans-serif';
  text-transform: capitalize;
}

/* Ajuste para que el contenido no se esconda debajo del navbar */
.main-content {
  padding-top: 60px;
}

@media (max-width: 768px) {
  .navbar-fixed {
    align-items: center;
    padding-right: 0;
    left: 0;
    right: 0;
    text-align: center;
  }

  .brand-title {
    font-size: 1.1rem;
  }

  .fecha-hora {
    font-size: 0.65rem;
    margin-top: -2px;
  }
}

</style>
